module.exports = __webpack_public_path__ + "static/media/empty.13f6c0de.png";